import BaseApi from '../base/base'
import User from '../../models/user'
import UserForm from '../../forms/user_form'

export default class UserApi extends BaseApi {
  constructor() {
    super()
    this.path = '/user'
  }

  async get(params = {}) {
    this.path = '/user'
    const response = await this.getRequest(params)
    const user = new User(response.data)
    return user
  }

  async patch(userForm: UserForm) {
    this.path = `/user`
    await this.postFormData(userForm.toFormData())
  }

  async destroy(password: string, reason: string, otherReason: string) {
    this.path = `/user/delete`
    await this.deleteRequest({ password, delete_reason: reason, other_reason: otherReason })
    return
  }

  async updateLearnTimeGoalValue(learnTimeGoalValue: number) {
    this.path = `/user/update_learn_time_goal_value`
    const response = await this.postRequest({
      learnTimeGoalValue
    })
    const user = new User(response.data)
    return user
  }
}
